export default __webpack_public_path__ + "static/media/login_bg_top.d0c00fb1.png";